import React from 'react'
import Base from './Base'

export default props => (
  <Base {...props}>
    <path d='M34,4H14A10,10,0,0,0,4,14V34A10,10,0,0,0,14,44H34A10,10,0,0,0,44,34V14A10,10,0,0,0,34,4ZM19.061,26.939a1.5,1.5,0,0,1-2.122,2.122l-4-4a1.5,1.5,0,0,1,0-2.122l4-4a1.5,1.5,0,0,1,2.122,2.122L16.121,24Zm8.381-9.527-4,14a1.5,1.5,0,0,1-2.884-.824l4-14a1.5,1.5,0,1,1,2.884.824Zm7.619,7.649-4,4a1.5,1.5,0,0,1-2.122-2.122L31.879,24l-2.94-2.939a1.5,1.5,0,0,1,2.122-2.122l4,4A1.5,1.5,0,0,1,35.061,25.061Z' />
  </Base>
)
